var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorblock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 334,
    viewBox: "0 0 428 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 110,
    transform: "translate(-36 223.778)",
    fill: "#027B44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 167,
    transform: "translate(89 166.778)",
    fill: "#CD7A14"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 248,
    transform: "translate(214 85.7778)",
    fill: "#027B44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 125.167,
    height: 166.889,
    transform: "translate(339)",
    fill: "#CD7A14"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 125.167,
    height: 166.889,
    transform: "translate(339 166.889)",
    fill: "#FFDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorblock2);
export default __webpack_public_path__ + "static/media/colorblock2.2976faa628b10c2e1263cafaa9995b52.svg";
export { ForwardRef as ReactComponent };